import DocumentToolBar from "./DocumentToolBar";

export default DocumentToolBar;



// WEBPACK FOOTER //
// ./src/components/DocumentToolBar/index.js